<template>
  <Card tag="form" class="residential-template-mutate-basis" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="residential-template-mutate-basis__input">
        <CustomFields
          data-field="fields"
          :value="value"
          @input="e => $emit('updateValue', e)"
          :schema="schemas"
          :data="value"
          :validator="validator"
          :placement="['residential-template:basis']"
        >
          <!-- render slots -->
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer :item="item" :value="value" @input="e => $emit('updateValue', { ...e, slot: true })" />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import { i18n } from '@/i18n'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Residential/StepsFields/FieldRenderer.vue'

const meta = {
  order: 1,
  id: 'basis',
  label: i18n.tc('basis'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    schemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
  },

  components: {
    Card,
    CustomFields,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.residential-template-mutate-basis {
  max-width: 900px;

  &__input {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: flex-start;
    grid-gap: 1rem;
  }

  [data-field='fields'],
  [data-field='price'] {
    grid-column-end: span 2;
  }

  // &:has([data-field='internal-name']) [data-field='name'] {
  //   grid-column-end: span 1;
  // }
}
</style>
